export default {
  hex2rgb (hex, opacity) {
    hex = (hex + '').trim()

    let rgb = null
    let match = hex.match(/^#?(([0-9a-zA-Z]{3}){1,3})$/)

    if (!match) {
      return null
    }

    rgb = {}

    hex = match[1]

    if (hex.length === 6) {
      rgb.r = parseInt(hex.substring(0, 2), 16)
      rgb.g = parseInt(hex.substring(2, 4), 16)
      rgb.b = parseInt(hex.substring(4, 6), 16)
    } else if (hex.length === 3) {
      rgb.r = parseInt(hex.substring(0, 1) + hex.substring(0, 1), 16)
      rgb.g = parseInt(hex.substring(1, 2) + hex.substring(1, 2), 16)
      rgb.b = parseInt(hex.substring(2, 3) + hex.substring(2, 3), 16)
    }

    rgb.css = 'rgb' + (opacity ? 'a' : '') + '('
    rgb.css += rgb.r + ',' + rgb.g + ',' + rgb.b
    rgb.css += (opacity ? ',' + opacity : '') + ')'

    return rgb
  },

  findInNestedByName (array, name) {
    if (typeof array !== 'undefined') {
      for (let i = 0; i < array.length; i++) {
        if (array[i].name === name) return [{...array[i]}]
        let a = this.findInNestedByName(array[i].children, name)
        if (a != null) {
          a.unshift({...array[i]})
          return [...a]
        }
      }
    }
    return null
  },

  compareAndKeepSameValues: function (obj1, obj2) {
    var self = this
    // If either object is null, return null
    if (obj1 === null || obj2 === null) {
      return null
    }

    // If both objects are primitives or have different types, compare directly
    if ((typeof obj1 !== 'object') || (typeof obj2 !== 'object')) {
      return obj1 === obj2 ? obj1 : null
    }

    // Initialize the result object
    const result = {}

    // Iterate over keys of obj1
    for (const key in obj1) {
      // If the key exists in both objects
      if (obj2.hasOwnProperty(key)) {
        // Recursively compare nested objects
        const nestedComparison = self.compareAndKeepSameValues(obj1[key], obj2[key])
        // If the nested comparison is not null, assign it to the result
        if (nestedComparison !== null) {
          result[key] = nestedComparison
        } else {
          // If the nested comparison is null, assign null to the result
          result[key] = null
        }
      } else {
        // If the key does not exist in obj2, assign null to the result
        result[key] = null
      }
    }

    return result
  },
}



// WEBPACK FOOTER //
// ./src/services/utils.js